import { ReservationWorkerFragment } from "@stepapp/core";
import { CategoryType } from "@stepapp/core/apiTypes";
import { Divider, spacing } from "@stepapp/ui";
import { KeyboardAvoidingView, Platform, ScrollView } from "react-native";
import { EditReservationQuestionType } from "../../store/types";
import Footer from "./Footer";
import Heading from "./Heading";

type EditAttributesProps = {
  children: React.ReactNode;
  questionType?: EditReservationQuestionType;
  date?: {
    day: string;
    hour: string;
  };
  workers?: ReservationWorkerFragment[];
  categoryType?: CategoryType | null;
  loading: boolean;
  handleSaveChanges: () => void;
  handleClose: () => void;
  isSubmitDisabled?: boolean;
  buttonLabel?: string;
  priceDetails?: {
    currentReservationPrice?: number;
    priceDifference: number;
    newPrice?: number | null;
  };
  noteAsModal?: boolean;
};

const EditContentContainer = ({
  children,
  questionType,
  date,
  workers,
  loading,
  handleSaveChanges,
  handleClose,
  isSubmitDisabled = false,
  priceDetails,
  buttonLabel,
  categoryType,
  noteAsModal = true,
}: EditAttributesProps) => {
  return (
    <>
      {noteAsModal && (
        <Heading
          date={date?.day || ""}
          handleClose={handleClose}
          questionType={questionType || ""}
          selectedHour={date?.hour || ""}
          workers={workers}
          categoryType={categoryType}
        />
      )}

      <KeyboardAvoidingView
        behavior={Platform.select({ default: "padding", android: undefined })}
        keyboardVerticalOffset={spacing.unit * (noteAsModal ? 10 : 18)}
        style={{ flex: 1 }}
      >
        <ScrollView>{children}</ScrollView>
      </KeyboardAvoidingView>

      <Divider spaceless />

      <Footer
        buttonLabel={buttonLabel}
        priceDetails={priceDetails}
        loading={loading}
        isSubmitDisabled={isSubmitDisabled}
        handleSaveChanges={handleSaveChanges}
      />
    </>
  );
};

export default EditContentContainer;
